import React from 'react';
import { TrendingUp, TrendingDown, Minus, Target } from 'lucide-react';

const RankTrackingTable = ({ keywords, onRefresh }) => {
  const keywordsWithRanking = keywords?.filter(k => k?.current_ranking);

  return (
    <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
      <div className="flex items-center mb-4">
        <Target className="w-6 h-6 text-green-600 mr-2" />
        <h3 className="text-lg font-semibold text-gray-900">Suivi des positions</h3>
      </div>

      <div className="overflow-x-auto">
        <table className="w-full">
          <thead className="bg-gray-50 border-b border-gray-200">
            <tr>
              <th className="px-4 py-3 text-left text-xs font-medium text-gray-600 uppercase">Mot-clé</th>
              <th className="px-4 py-3 text-left text-xs font-medium text-gray-600 uppercase">Position actuelle</th>
              <th className="px-4 py-3 text-left text-xs font-medium text-gray-600 uppercase">Position cible</th>
              <th className="px-4 py-3 text-left text-xs font-medium text-gray-600 uppercase">Écart</th>
              <th className="px-4 py-3 text-left text-xs font-medium text-gray-600 uppercase">Volume</th>
              <th className="px-4 py-3 text-left text-xs font-medium text-gray-600 uppercase">URL cible</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-200">
            {keywordsWithRanking?.map((keyword) => {
              const gap = keyword?.target_ranking
                ? keyword?.current_ranking - keyword?.target_ranking
                : null;

              return (
                <tr key={keyword?.id} className="hover:bg-gray-50">
                  <td className="px-4 py-3 text-sm text-gray-900 font-medium">{keyword?.keyword}</td>
                  <td className="px-4 py-3">
                    <span className={`px-3 py-1 text-sm font-bold rounded-full ${
                      keyword?.current_ranking <= 3 ? 'bg-green-100 text-green-800' :
                      keyword?.current_ranking <= 10 ? 'bg-blue-100 text-blue-800' :
                      keyword?.current_ranking <= 20 ? 'bg-yellow-100 text-yellow-800': 'bg-red-100 text-red-800'
                    }`}>
                      #{keyword?.current_ranking}
                    </span>
                  </td>
                  <td className="px-4 py-3 text-sm text-gray-600">
                    {keyword?.target_ranking ? `#${keyword?.target_ranking}` : '-'}
                  </td>
                  <td className="px-4 py-3">
                    {gap !== null ? (
                      <div className="flex items-center">
                        {gap > 0 ? (
                          <>
                            <TrendingDown size={16} className="text-red-600 mr-1" />
                            <span className="text-sm text-red-600 font-medium">+{gap}</span>
                          </>
                        ) : gap < 0 ? (
                          <>
                            <TrendingUp size={16} className="text-green-600 mr-1" />
                            <span className="text-sm text-green-600 font-medium">{gap}</span>
                          </>
                        ) : (
                          <>
                            <Minus size={16} className="text-gray-400 mr-1" />
                            <span className="text-sm text-gray-600">0</span>
                          </>
                        )}
                      </div>
                    ) : (
                      <span className="text-gray-400">-</span>
                    )}
                  </td>
                  <td className="px-4 py-3 text-sm text-gray-600">{keyword?.search_volume?.toLocaleString()}</td>
                  <td className="px-4 py-3 text-sm text-blue-600 hover:underline">
                    {keyword?.target_url || '-'}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>

      {keywordsWithRanking?.length === 0 && (
        <div className="text-center py-12">
          <Target className="w-12 h-12 text-gray-400 mx-auto mb-3" />
          <p className="text-gray-500">Aucun mot-clé avec position suivie</p>
        </div>
      )}
    </div>
  );
};

export default RankTrackingTable;